import React from 'react';
import { makeStyles } from '@material-ui/styles';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { Link as RouterLink } from 'react-router-dom';
import {
    Card,
    CardContent,
    Grid,
    Typography,
    Avatar,
    CardActionArea
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    content: {
        alignItems: 'center',
        display: 'flex'
    },
    title: {
        fontWeight: 700
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
        height: 56,
        width: 56
    },
    icon: {
        height: 32,
        width: 32
    },
    difference: {
        marginTop: theme.spacing(2),
        display: 'flex',
        alignItems: 'center'
    },
    differenceIcon: {
        color: theme.palette.success.dark
    },
    differenceValue: {
        color: theme.palette.success.dark,
        marginRight: theme.spacing(1)
    },
    labelAction: {
        width: '100%',
        textAlign: 'center'
    },
    footer: {
        padding: 10,
        display: 'flex',
        alignItems: 'center',
        textAlign: "center"
    },
}));

const InfoCard = props => {
    const { className, data, filter, ...rest } = props;

    const classes = useStyles();

    return (
        <Card>
            <CardContent>
                <Grid
                    container
                    justify="space-between"
                    alignItems="center"
                >
                    <Grid item>
                        <Typography
                            color="textSecondary"
                            //className={classes.title}
                            gutterBottom
                            variant="body2"
                        >
                            {filter == "t" ? "Titulaires" : "Passagers"} présents
                        </Typography>
                        <Grid container direction="row"
                            justify="flex-start"
                            alignItems="flex-end" spacing={1}>
                            <Grid item>
                                <Typography variant="h3">{data.present}</Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="body2">/ {data.all}</Typography>
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid item>
                        <Avatar className={classes.avatar}>
                            <AssignmentTurnedInIcon className={classes.icon} />
                        </Avatar>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default InfoCard;
